export default {
  namespaced: true,
  state: {
    title: 'Review your information',
    description:
      'Please check all the information you have provided before you submit to your manager.',
  },
  // getters: {},
  // mutations: {},
  // actions: {},
};
